var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasScore)?_c('div',{staticClass:"ai-suggest-score"},[_vm._v(" "+_vm._s(_vm.$t('mark_ai_suggest_score'))+": "+_vm._s(_vm.score)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }